function getCssValue(element, property) {
  /**.cssの値取得 */
  if (!element || !property) {
    return null;
  }
  const style = window.getComputedStyle(element);
  const value = style.getPropertyValue(property);
  return value;
}

(() => {
  objectFitImages();

  /**
   * メディアクエリでの分岐
   * mqstr cssのブレイクポイントと合わせる
   * md:(min-width: 960px)
   */
  const mqstr = "(min-width: 1140px)";

  const mql = window.matchMedia(mqstr);
  let isMatche = false;

  function init() {
    //matchMedia
    mql.addListener(resizeHandler);
    resizeHandler(mql);

    //menu
    if ("block" == getCssValue(toggleBtn, "display")) {
      initEvents();
    } else {
      delEvents();
    }

    initScrollTop();
  }

  function resizeHandler(evt) {
    isMatche = evt.matches;
    if (isMatche) {
      //PC
    } else {
      //SP
    }
  }

  /**
   * メニューの開閉
   */
  const bodyEl = document.body,
    toggleBtn = document.getElementsByClassName("js-menutoggle")[0];
  let isOpen = false;

  function initEvents() {
    toggleBtn.addEventListener("click", toggleMenu);
  }
  function delEvents() {
    toggleBtn.removeEventListener("click", toggleMenu);
    bodyEl.classList.remove("has-menuOpen");
    isOpen = false;
  }

  function toggleMenu() {
    if (isOpen) {
      bodyEl.classList.remove("has-menuOpen");
      toggleBtn.classList.remove("is-act");
    } else {
      bodyEl.classList.add("has-menuOpen");
      toggleBtn.classList.add("is-act");
    }
    isOpen = !isOpen;
  }

  /**
   * ナビゲーション関連のスクロール制御
   */

  /* site-headerをスクロールで非表示 */
  const header = document.getElementsByClassName("js-header")[0],
    height = 65,
    blank = 50,
    shrinkspace = 300;

  let offset = 0;

  function headerScroll(nowPosition) {
    if (nowPosition > height) {
      offset = nowPosition;
      // スクロールでheader縮小
      if (nowPosition > shrinkspace) {
        header.classList.add("is-shrink");
      } else {
        header.classList.remove("is-shrink");
      }
    }
  }

  /* toTopをスクロールで非表示 */
  const topbtn = document.querySelector(".js-pagetop"),
    top_container = document.querySelector(".js-pagetop-container"),
    topbtnOffset = 200;
  function topBtnScroll(nowPosition) {
    top_container.classList.add("is-hide");
    setTimeout(() => {
      top_container.classList.remove("is-hide");
    }, 1000);
    if (nowPosition > topbtnOffset) {
      top_container.classList.add("is-act");
    } else {
      top_container.classList.remove("is-act");
    }
  }

  function initScrollTop() {
    const duration = 250;
    let target = topbtn;
    target.addEventListener("click", function() {
      let currentY = window.pageYOffset;
      let step = 1 < duration / currentY ? 10 : 100;
      let timeStep = (duration / currentY) * step;
      let intervalID = setInterval(scrollUp, timeStep);
      function scrollUp() {
        currentY = window.pageYOffset;
        if (0 === currentY) {
          clearInterval(intervalID);
        } else {
          scrollBy(0, -step);
        }
      }
    });
  }

  /* 言語リストの開閉 */

  let isLangOpen = false;
  if (document.getElementsByClassName("js-languageswitch").length) {
    const languageSwitch = document.getElementsByClassName(
        "js-languageswitch"
      )[0],
      switchBtn = languageSwitch.getElementsByClassName("btn-switch")[0];
    switchBtn.addEventListener("click", toggleLanguageList);
    function toggleLanguageList() {
      if (isLangOpen) {
        languageSwitch.classList.remove("has-open");
      } else {
        languageSwitch.classList.add("has-open");
      }
      isLangOpen = !isLangOpen;
    }
  }

  /* スクロールチェック */
  let ticking = false;
  function scrollHandler() {
    let nowPosition =
      window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (!isOpen) headerScroll(nowPosition);

        topBtnScroll(nowPosition);
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener("scroll", scrollHandler, false);
  window.addEventListener("touchmove", scrollHandler, false);

  init();

  window.sr = ScrollReveal();
  sr.reveal(".fade-anime", {
    easing: "ease-out",
    duration: 750,
    distance: "100px",
    opacity: 0,
    scale: 1,
    mobile: false
  });
})();
